<div class="card mb-0 main-card overflow-auto">
  <div class="card-header">
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="card-title align-items-center d-flex p-0">Neurologist</h5>
      <div class="d-flex">
        <date-range-picker (toDateChange)="toDateChange($event)" (fromDateChange)="fromDateChange($event)"></date-range-picker>
        <div class="search-bar">
          <div class="form-group">
            <div class="input-group has-prefix">
              <i class="prefix bi bi-search"></i>
              <input type="text" class="form-control" name="query" placeholder="Search Neurologist" title="Search Neurologist" (keyup)="SearchData()" [(ngModel)]="SearchVal" />
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-outline-primary" (click)="exportReport()" [disabled]="isLoading">
          {{ isLoading ? 'Exporting...' : 'Export' }}<i class="bi bi-box-arrow-right fs-5 mx-1"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="card-body p-0">
    <div class="table-responsive h-100">
      <table class="table table-hover table-x-padding mb-0" *ngIf="TotaReports || IsLoading">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">
              <button class="btn btn-sm p-0 btn-sort" (click)="SortData('firstName')" [ngClass]="this.PaginationParams.sortColumn === 'firstName' ? this.PaginationParams.sortOrder : ''">
                Name
                <i class="text-body-tertiary bi-arrow-down-short"></i>
              </button>
            </th>
            <th scope="col">Case Type</th>
            <th scope="col">Phone</th>
            <th scope="col">
              <button class="btn btn-sm p-0 btn-sort" (click)="SortData('dateofAccident')" [ngClass]="this.PaginationParams.sortColumn === 'dateofAccident' ? this.PaginationParams.sortOrder : ''">
                Date of Accident
                <i class="text-body-tertiary bi-arrow-down-short"></i>
              </button>
            </th>
            <th scope="col">
              <button
                class="btn btn-sm p-0 btn-sort"
                (click)="SortData('dateOfEntry')"
                [ngClass]="(PaginationParams.sortColumn === 'dateOfEntry' ? PaginationParams.sortOrder : '') + (currentClinic >= 1 ? ' text-end' : '')"
              >
                Date Of Entry
                <i class="text-body-tertiary bi-arrow-down-short"></i>
              </button>
            </th>
            <th *ngIf="currentClinic < 1" scope="col" class="text-end">Clinic Name</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="!IsLoading">
            <ng-container *ngFor="let item of reportList">
              <tr>
                <td colspan="7" style="font-weight: bold; background-color: #d7e4fe">Appointment Date : {{ item.date | date : 'MM/dd/yyyy' }}</td>
              </tr>
              <tr *ngFor="let patient of item.patientData; index as i">
                <!-- Patient Data Row -->
                <th scope="row">{{ i + 1 }}</th>
                <td>{{ patient.firstName }} {{ patient.lastName }}</td>
                <td>{{ patient.caseName }}</td>
                <td>{{ patient.phoneNumber | phonenumber : 'format' }}</td>
                <td>{{ patient.dateofAccident | date : 'MM/dd/yyyy' }}</td>
                <td [ngClass]="{ 'text-end': currentClinic >= 1 }">{{ patient.dateOfEntry | date : 'MM/dd/yyyy' }}</td>
                <td *ngIf="currentClinic < 1" class="text-end">{{ patient.clinicName }}</td>
              </tr>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="IsLoading">
            <tr *ngFor="let report of ['', '', '', '', '']; index as i">
              <td *ngFor="let report of ['', '', '', '', '', '', '']; index as i">
                <p class="placeholder-glow">
                  <span class="placeholder col-12"></span>
                </p>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <div class="empty-data-placeholder" *ngIf="TotaReports == 0 && !IsLoading">
        <div class="text-center">
          <h3 class="text-body-tertiary"><i class="bi bi-exclamation-triangle"></i> Oops..!</h3>
          <p>No Reports Found</p>
        </div>
      </div>
    </div>
  </div>
</div>
